import e from "dayjs";
import t from "dayjs/plugin/isSameOrAfter";
import n from "dayjs/plugin/isSameOrBefore";
e.extend(t), e.extend(n);
var r = /^\d{4}-\d{2}-\d{2}$/;
function i(t, n, i) {
	return t ? (t.length >= 10 && (t = t.slice(0, 10)), r.test(t) ? e(t, "YYYY-MM-DD", !0).isValid() ? a(t, n, i) ? {
		is_valid: !0,
		message: ""
	} : {
		message: "This date is out of range",
		is_valid: !1
	} : {
		message: "Invalid date",
		is_valid: !1
	} : {
		message: "Invalid format",
		is_valid: !1
	}) : {
		message: "valid because no date is provided",
		is_valid: !0
	};
}
function a(t, n, r) {
	return !n && !r || n && r && t && e(t).isSame(n) && e(t).isSame(r) ? !0 : !(n && e(t).isBefore(n) || r && e(t).isAfter(r));
}
function o(e, t, n) {
	let r = Math.floor(e / 10) * 10, i = [];
	for (let e = r; e < r + 10; e++) (t !== -1 && e < t || n !== -1 && e > n) && i.push(e);
	return i;
}
function s(e) {
	let t = Math.floor(e / 10) * 10, n = [];
	for (let e = t; e < t + 10; e++) n.push(e);
	return n;
}
var c = (e) => e ? e.length < 10 ? e : `${e[0]}${e[1]}${e[2]}${e[3]}-${e[5]}${e[6]}-${e[8]}${e[9]}` : "";
export { a as check_if_in_range, r as dateFormat, o as get_year_list_in_decade, s as get_year_list_in_decade_for_en_ctx, c as parseSafeDate, i as validate };

//# sourceMappingURL=utils.js.map